const countriesEs = [
  {
    "es": "Afganistán",
    "code": "AF",
    "iso3": "AFG",
    "phoneCode": "93"
  },
  {
    "es": "Albania",
    "code": "AL",
    "iso3": "ALB",
    "phoneCode": "355"
  },
  {
    "es": "Alemania",
    "code": "DE",
    "iso3": "DEU",
    "phoneCode": "49"
  },
  {
    "es": "Andorra",
    "code": "AD",
    "iso3": "AND",
    "phoneCode": "376"
  },
  {
    "es": "Angola",
    "code": "AO",
    "iso3": "AGO",
    "phoneCode": "244"
  },
  {
    "es": "Anguila",
    "code": "AI",
    "iso3": "AIA",
    "phoneCode": "1 264"
  },
  {
    "es": "Antártida",
    "code": "AQ",
    "iso3": "ATA",
    "phoneCode": "672"
  },
  {
    "es": "Antigua y Barbuda",
    "code": "AG",
    "iso3": "ATG",
    "phoneCode": "1 268"
  },
  {
    "es": "Arabia Saudita",
    "code": "SA",
    "iso3": "SAU",
    "phoneCode": "966"
  },
  {
    "es": "Argelia",
    "code": "DZ",
    "iso3": "DZA",
    "phoneCode": "213"
  },
  {
    "es": "Argentina",
    "code": "AR",
    "iso3": "ARG",
    "phoneCode": "54"
  },
  {
    "es": "Armenia",
    "code": "AM",
    "iso3": "ARM",
    "phoneCode": "374"
  },
  {
    "es": "Aruba",
    "code": "AW",
    "iso3": "ABW",
    "phoneCode": "297"
  },
  {
    "es": "Australia",
    "code": "AU",
    "iso3": "AUS",
    "phoneCode": "61"
  },
  {
    "es": "Austria",
    "code": "AT",
    "iso3": "AUT",
    "phoneCode": "43"
  },
  {
    "es": "Azerbaiyán",
    "code": "AZ",
    "iso3": "AZE",
    "phoneCode": "994"
  },
  {
    "es": "Bélgica",
    "code": "BE",
    "iso3": "BEL",
    "phoneCode": "32"
  },
  {
    "es": "Bahamas",
    "code": "BS",
    "iso3": "BHS",
    "phoneCode": "1 242"
  },
  {
    "es": "Bahrein",
    "code": "BH",
    "iso3": "BHR",
    "phoneCode": "973"
  },
  {
    "es": "Bangladesh",
    "code": "BD",
    "iso3": "BGD",
    "phoneCode": "880"
  },
  {
    "es": "Barbados",
    "code": "BB",
    "iso3": "BRB",
    "phoneCode": "1 246"
  },
  {
    "es": "Belice",
    "code": "BZ",
    "iso3": "BLZ",
    "phoneCode": "501"
  },
  {
    "es": "Benín",
    "code": "BJ",
    "iso3": "BEN",
    "phoneCode": "229"
  },
  {
    "es": "Bhután",
    "code": "BT",
    "iso3": "BTN",
    "phoneCode": "975"
  },
  {
    "es": "Bielorrusia",
    "code": "BY",
    "iso3": "BLR",
    "phoneCode": "375"
  },
  {
    "es": "Birmania",
    "code": "MM",
    "iso3": "MMR",
    "phoneCode": "95"
  },
  {
    "es": "Bolivia",
    "code": "BO",
    "iso3": "BOL",
    "phoneCode": "591"
  },
  {
    "es": "Bosnia y Herzegovina",
    "code": "BA",
    "iso3": "BIH",
    "phoneCode": "387"
  },
  {
    "es": "Botsuana",
    "code": "BW",
    "iso3": "BWA",
    "phoneCode": "267"
  },
  {
    "es": "Brasil",
    "code": "BR",
    "iso3": "BRA",
    "phoneCode": "55"
  },
  {
    "es": "Brunéi",
    "code": "BN",
    "iso3": "BRN",
    "phoneCode": "673"
  },
  {
    "es": "Bulgaria",
    "code": "BG",
    "iso3": "BGR",
    "phoneCode": "359"
  },
  {
    "es": "Burkina Faso",
    "code": "BF",
    "iso3": "BFA",
    "phoneCode": "226"
  },
  {
    "es": "Burundi",
    "code": "BI",
    "iso3": "BDI",
    "phoneCode": "257"
  },
  {
    "es": "Cabo Verde",
    "code": "CV",
    "iso3": "CPV",
    "phoneCode": "238"
  },
  {
    "es": "Camboya",
    "code": "KH",
    "iso3": "KHM",
    "phoneCode": "855"
  },
  {
    "es": "Camerún",
    "code": "CM",
    "iso3": "CMR",
    "phoneCode": "237"
  },
  {
    "es": "Canadá",
    "code": "CA",
    "iso3": "CAN",
    "phoneCode": "1"
  },
  {
    "es": "Chad",
    "code": "TD",
    "iso3": "TCD",
    "phoneCode": "235"
  },
  {
    "es": "Chile",
    "code": "CL",
    "iso3": "CHL",
    "phoneCode": "56"
  },
  {
    "es": "China",
    "code": "CN",
    "iso3": "CHN",
    "phoneCode": "86"
  },
  {
    "es": "Chipre",
    "code": "CY",
    "iso3": "CYP",
    "phoneCode": "357"
  },
  {
    "es": "Ciudad del Vaticano",
    "code": "VA",
    "iso3": "VAT",
    "phoneCode": "39"
  },
  {
    "es": "Colombia",
    "code": "CO",
    "iso3": "COL",
    "phoneCode": "57"
  },
  {
    "es": "Comoras",
    "code": "KM",
    "iso3": "COM",
    "phoneCode": "269"
  },
  {
    "es": "República del Congo",
    "code": "CG",
    "iso3": "COG",
    "phoneCode": "242"
  },
  {
    "es": "República Democrática del Congo",
    "code": "CD",
    "iso3": "COD",
    "phoneCode": "243"
  },
  {
    "es": "Corea del Norte",
    "code": "KP",
    "iso3": "PRK",
    "phoneCode": "850"
  },
  {
    "es": "Corea del Sur",
    "code": "KR",
    "iso3": "KOR",
    "phoneCode": "82"
  },
  {
    "es": "Costa de Marfil",
    "code": "CI",
    "iso3": "CIV",
    "phoneCode": "225"
  },
  {
    "es": "Costa Rica",
    "code": "CR",
    "iso3": "CRI",
    "phoneCode": "506"
  },
  {
    "es": "Croacia",
    "code": "HR",
    "iso3": "HRV",
    "phoneCode": "385"
  },
  {
    "es": "Cuba",
    "code": "CU",
    "iso3": "CUB",
    "phoneCode": "53"
  },
  {
    "es": "Curazao",
    "code": "CW",
    "iso3": "CWU",
    "phoneCode": "5999"
  },
  {
    "es": "Dinamarca",
    "code": "DK",
    "iso3": "DNK",
    "phoneCode": "45"
  },
  {
    "es": "Dominica",
    "code": "DM",
    "iso3": "DMA",
    "phoneCode": "1 767"
  },
  {
    "es": "Ecuador",
    "code": "EC",
    "iso3": "ECU",
    "phoneCode": "593"
  },
  {
    "es": "Egipto",
    "code": "EG",
    "iso3": "EGY",
    "phoneCode": "20"
  },
  {
    "es": "El Salvador",
    "code": "SV",
    "iso3": "SLV",
    "phoneCode": "503"
  },
  {
    "es": "Emiratos Árabes Unidos",
    "code": "AE",
    "iso3": "ARE",
    "phoneCode": "971"
  },
  {
    "es": "Eritrea",
    "code": "ER",
    "iso3": "ERI",
    "phoneCode": "291"
  },
  {
    "es": "Eslovaquia",
    "code": "SK",
    "iso3": "SVK",
    "phoneCode": "421"
  },
  {
    "es": "Eslovenia",
    "code": "SI",
    "iso3": "SVN",
    "phoneCode": "386"
  },
  {
    "es": "España",
    "code": "ES",
    "iso3": "ESP",
    "phoneCode": "34"
  },
  {
    "es": "Estados Unidos de América",
    "code": "US",
    "iso3": "USA",
    "phoneCode": "1"
  },
  {
    "es": "Estonia",
    "code": "EE",
    "iso3": "EST",
    "phoneCode": "372"
  },
  {
    "es": "Etiopía",
    "code": "ET",
    "iso3": "ETH",
    "phoneCode": "251"
  },
  {
    "es": "Filipinas",
    "code": "PH",
    "iso3": "PHL",
    "phoneCode": "63"
  },
  {
    "es": "Finlandia",
    "code": "FI",
    "iso3": "FIN",
    "phoneCode": "358"
  },
  {
    "es": "Fiyi",
    "code": "FJ",
    "iso3": "FJI",
    "phoneCode": "679"
  },
  {
    "es": "Francia",
    "code": "FR",
    "iso3": "FRA",
    "phoneCode": "33"
  },
  {
    "es": "Gabón",
    "code": "GA",
    "iso3": "GAB",
    "phoneCode": "241"
  },
  {
    "es": "Gambia",
    "code": "GM",
    "iso3": "GMB",
    "phoneCode": "220"
  },
  {
    "es": "Georgia",
    "code": "GE",
    "iso3": "GEO",
    "phoneCode": "995"
  },
  {
    "es": "Ghana",
    "code": "GH",
    "iso3": "GHA",
    "phoneCode": "233"
  },
  {
    "es": "Gibraltar",
    "code": "GI",
    "iso3": "GIB",
    "phoneCode": "350"
  },
  {
    "es": "Granada",
    "code": "GD",
    "iso3": "GRD",
    "phoneCode": "1 473"
  },
  {
    "es": "Grecia",
    "code": "GR",
    "iso3": "GRC",
    "phoneCode": "30"
  },
  {
    "es": "Groenlandia",
    "code": "GL",
    "iso3": "GRL",
    "phoneCode": "299"
  },
  {
    "es": "Guadalupe",
    "code": "GP",
    "iso3": "GLP",
    "phoneCode": "590"
  },
  {
    "es": "Guam",
    "code": "GU",
    "iso3": "GUM",
    "phoneCode": "1 671"
  },
  {
    "es": "Guatemala",
    "code": "GT",
    "iso3": "GTM",
    "phoneCode": "502"
  },
  {
    "es": "Guayana Francesa",
    "code": "GF",
    "iso3": "GUF",
    "phoneCode": "594"
  },
  {
    "es": "Guernsey",
    "code": "GG",
    "iso3": "GGY",
    "phoneCode": "44"
  },
  {
    "es": "Guinea",
    "code": "GN",
    "iso3": "GIN",
    "phoneCode": "224"
  },
  {
    "es": "Guinea Ecuatorial",
    "code": "GQ",
    "iso3": "GNQ",
    "phoneCode": "240"
  },
  {
    "es": "Guinea-Bissau",
    "code": "GW",
    "iso3": "GNB",
    "phoneCode": "245"
  },
  {
    "es": "Guyana",
    "code": "GY",
    "iso3": "GUY",
    "phoneCode": "592"
  },
  {
    "es": "Haití",
    "code": "HT",
    "iso3": "HTI",
    "phoneCode": "509"
  },
  {
    "es": "Honduras",
    "code": "HN",
    "iso3": "HND",
    "phoneCode": "504"
  },
  {
    "es": "Hong kong",
    "code": "HK",
    "iso3": "HKG",
    "phoneCode": "852"
  },
  {
    "es": "Hungría",
    "code": "HU",
    "iso3": "HUN",
    "phoneCode": "36"
  },
  {
    "es": "India",
    "code": "IN",
    "iso3": "IND",
    "phoneCode": "91"
  },
  {
    "es": "Indonesia",
    "code": "ID",
    "iso3": "IDN",
    "phoneCode": "62"
  },
  {
    "es": "Irán",
    "code": "IR",
    "iso3": "IRN",
    "phoneCode": "98"
  },
  {
    "es": "Irak",
    "code": "IQ",
    "iso3": "IRQ",
    "phoneCode": "964"
  },
  {
    "es": "Irlanda",
    "code": "IE",
    "iso3": "IRL",
    "phoneCode": "353"
  },
  {
    "es": "Isla Bouvet",
    "code": "BV",
    "iso3": "BVT",
    "phoneCode": ""
  },
  {
    "es": "Isla de Man",
    "code": "IM",
    "iso3": "IMN",
    "phoneCode": "44"
  },
  {
    "es": "Isla de Navidad",
    "code": "CX",
    "iso3": "CXR",
    "phoneCode": "61"
  },
  {
    "es": "Isla Norfolk",
    "code": "NF",
    "iso3": "NFK",
    "phoneCode": "672"
  },
  {
    "es": "Islandia",
    "code": "IS",
    "iso3": "ISL",
    "phoneCode": "354"
  },
  {
    "es": "Islas Bermudas",
    "code": "BM",
    "iso3": "BMU",
    "phoneCode": "1 441"
  },
  {
    "es": "Islas Caimán",
    "code": "KY",
    "iso3": "CYM",
    "phoneCode": "1 345"
  },
  {
    "es": "Islas Cocos (Keeling)",
    "code": "CC",
    "iso3": "CCK",
    "phoneCode": "61"
  },
  {
    "es": "Islas Cook",
    "code": "CK",
    "iso3": "COK",
    "phoneCode": "682"
  },
  {
    "es": "Islas de Åland",
    "code": "AX",
    "iso3": "ALA",
    "phoneCode": "358"
  },
  {
    "es": "Islas Feroe",
    "code": "FO",
    "iso3": "FRO",
    "phoneCode": "298"
  },
  {
    "es": "Islas Georgias del Sur y Sandwich del Sur",
    "code": "GS",
    "iso3": "SGS",
    "phoneCode": "500"
  },
  {
    "es": "Islas Heard y McDonald",
    "code": "HM",
    "iso3": "HMD",
    "phoneCode": ""
  },
  {
    "es": "Islas Maldivas",
    "code": "MV",
    "iso3": "MDV",
    "phoneCode": "960"
  },
  {
    "es": "Islas Malvinas",
    "code": "FK",
    "iso3": "FLK",
    "phoneCode": "500"
  },
  {
    "es": "Islas Marianas del Norte",
    "code": "MP",
    "iso3": "MNP",
    "phoneCode": "1 670"
  },
  {
    "es": "Islas Marshall",
    "code": "MH",
    "iso3": "MHL",
    "phoneCode": "692"
  },
  {
    "es": "Islas Pitcairn",
    "code": "PN",
    "iso3": "PCN",
    "phoneCode": "870"
  },
  {
    "es": "Islas Salomón",
    "code": "SB",
    "iso3": "SLB",
    "phoneCode": "677"
  },
  {
    "es": "Islas Turcas y Caicos",
    "code": "TC",
    "iso3": "TCA",
    "phoneCode": "1 649"
  },
  {
    "es": "Islas Ultramarinas Menores de Estados Unidos",
    "code": "UM",
    "iso3": "UMI",
    "phoneCode": "246"
  },
  {
    "es": "Islas Vírgenes Británicas",
    "code": "VG",
    "iso3": "VGB",
    "phoneCode": "1 284"
  },
  {
    "es": "Islas Vírgenes de los Estados Unidos",
    "code": "VI",
    "iso3": "VIR",
    "phoneCode": "1 340"
  },
  {
    "es": "Israel",
    "code": "IL",
    "iso3": "ISR",
    "phoneCode": "972"
  },
  {
    "es": "Italia",
    "code": "IT",
    "iso3": "ITA",
    "phoneCode": "39"
  },
  {
    "es": "Jamaica",
    "code": "JM",
    "iso3": "JAM",
    "phoneCode": "1 876"
  },
  {
    "es": "Japón",
    "code": "JP",
    "iso3": "JPN",
    "phoneCode": "81"
  },
  {
    "es": "Jersey",
    "code": "JE",
    "iso3": "JEY",
    "phoneCode": "44"
  },
  {
    "es": "Jordania",
    "code": "JO",
    "iso3": "JOR",
    "phoneCode": "962"
  },
  {
    "es": "Kazajistán",
    "code": "KZ",
    "iso3": "KAZ",
    "phoneCode": "7"
  },
  {
    "es": "Kenia",
    "code": "KE",
    "iso3": "KEN",
    "phoneCode": "254"
  },
  {
    "es": "Kirguistán",
    "code": "KG",
    "iso3": "KGZ",
    "phoneCode": "996"
  },
  {
    "es": "Kiribati",
    "code": "KI",
    "iso3": "KIR",
    "phoneCode": "686"
  },
  {
    "es": "Kuwait",
    "code": "KW",
    "iso3": "KWT",
    "phoneCode": "965"
  },
  {
    "es": "Líbano",
    "code": "LB",
    "iso3": "LBN",
    "phoneCode": "961"
  },
  {
    "es": "Laos",
    "code": "LA",
    "iso3": "LAO",
    "phoneCode": "856"
  },
  {
    "es": "Lesoto",
    "code": "LS",
    "iso3": "LSO",
    "phoneCode": "266"
  },
  {
    "es": "Letonia",
    "code": "LV",
    "iso3": "LVA",
    "phoneCode": "371"
  },
  {
    "es": "Liberia",
    "code": "LR",
    "iso3": "LBR",
    "phoneCode": "231"
  },
  {
    "es": "Libia",
    "code": "LY",
    "iso3": "LBY",
    "phoneCode": "218"
  },
  {
    "es": "Liechtenstein",
    "code": "LI",
    "iso3": "LIE",
    "phoneCode": "423"
  },
  {
    "es": "Lituania",
    "code": "LT",
    "iso3": "LTU",
    "phoneCode": "370"
  },
  {
    "es": "Luxemburgo",
    "code": "LU",
    "iso3": "LUX",
    "phoneCode": "352"
  },
  {
    "es": "México",
    "code": "MX",
    "iso3": "MEX",
    "phoneCode": "52"
  },
  {
    "es": "Mónaco",
    "code": "MC",
    "iso3": "MCO",
    "phoneCode": "377"
  },
  {
    "es": "Macao",
    "code": "MO",
    "iso3": "MAC",
    "phoneCode": "853"
  },
  {
    "es": "Macedônia",
    "code": "MK",
    "iso3": "MKD",
    "phoneCode": "389"
  },
  {
    "es": "Madagascar",
    "code": "MG",
    "iso3": "MDG",
    "phoneCode": "261"
  },
  {
    "es": "Malasia",
    "code": "MY",
    "iso3": "MYS",
    "phoneCode": "60"
  },
  {
    "es": "Malawi",
    "code": "MW",
    "iso3": "MWI",
    "phoneCode": "265"
  },
  {
    "es": "Mali",
    "code": "ML",
    "iso3": "MLI",
    "phoneCode": "223"
  },
  {
    "es": "Malta",
    "code": "MT",
    "iso3": "MLT",
    "phoneCode": "356"
  },
  {
    "es": "Marruecos",
    "code": "MA",
    "iso3": "MAR",
    "phoneCode": "212"
  },
  {
    "es": "Martinica",
    "code": "MQ",
    "iso3": "MTQ",
    "phoneCode": "596"
  },
  {
    "es": "Mauricio",
    "code": "MU",
    "iso3": "MUS",
    "phoneCode": "230"
  },
  {
    "es": "Mauritania",
    "code": "MR",
    "iso3": "MRT",
    "phoneCode": "222"
  },
  {
    "es": "Mayotte",
    "code": "YT",
    "iso3": "MYT",
    "phoneCode": "262"
  },
  {
    "es": "Micronesia",
    "code": "FM",
    "iso3": "FSM",
    "phoneCode": "691"
  },
  {
    "es": "Moldavia",
    "code": "MD",
    "iso3": "MDA",
    "phoneCode": "373"
  },
  {
    "es": "Mongolia",
    "code": "MN",
    "iso3": "MNG",
    "phoneCode": "976"
  },
  {
    "es": "Montenegro",
    "code": "ME",
    "iso3": "MNE",
    "phoneCode": "382"
  },
  {
    "es": "Montserrat",
    "code": "MS",
    "iso3": "MSR",
    "phoneCode": "1 664"
  },
  {
    "es": "Mozambique",
    "code": "MZ",
    "iso3": "MOZ",
    "phoneCode": "258"
  },
  {
    "es": "Namibia",
    "code": "NA",
    "iso3": "NAM",
    "phoneCode": "264"
  },
  {
    "es": "Nauru",
    "code": "NR",
    "iso3": "NRU",
    "phoneCode": "674"
  },
  {
    "es": "Nepal",
    "code": "NP",
    "iso3": "NPL",
    "phoneCode": "977"
  },
  {
    "es": "Nicaragua",
    "code": "NI",
    "iso3": "NIC",
    "phoneCode": "505"
  },
  {
    "es": "Niger",
    "code": "NE",
    "iso3": "NER",
    "phoneCode": "227"
  },
  {
    "es": "Nigeria",
    "code": "NG",
    "iso3": "NGA",
    "phoneCode": "234"
  },
  {
    "es": "Niue",
    "code": "NU",
    "iso3": "NIU",
    "phoneCode": "683"
  },
  {
    "es": "Noruega",
    "code": "NO",
    "iso3": "NOR",
    "phoneCode": "47"
  },
  {
    "es": "Nueva Caledonia",
    "code": "NC",
    "iso3": "NCL",
    "phoneCode": "687"
  },
  {
    "es": "Nueva Zelanda",
    "code": "NZ",
    "iso3": "NZL",
    "phoneCode": "64"
  },
  {
    "es": "Omán",
    "code": "OM",
    "iso3": "OMN",
    "phoneCode": "968"
  },
  {
    "es": "Países Bajos",
    "code": "NL",
    "iso3": "NLD",
    "phoneCode": "31"
  },
  {
    "es": "Pakistán",
    "code": "PK",
    "iso3": "PAK",
    "phoneCode": "92"
  },
  {
    "es": "Palau",
    "code": "PW",
    "iso3": "PLW",
    "phoneCode": "680"
  },
  {
    "es": "Palestina",
    "code": "PS",
    "iso3": "PSE",
    "phoneCode": "970"
  },
  {
    "es": "Panamá",
    "code": "PA",
    "iso3": "PAN",
    "phoneCode": "507"
  },
  {
    "es": "Papúa Nueva Guinea",
    "code": "PG",
    "iso3": "PNG",
    "phoneCode": "675"
  },
  {
    "es": "Paraguay",
    "code": "PY",
    "iso3": "PRY",
    "phoneCode": "595"
  },
  {
    "es": "Perú",
    "code": "PE",
    "iso3": "PER",
    "phoneCode": "51"
  },
  {
    "es": "Polinesia Francesa",
    "code": "PF",
    "iso3": "PYF",
    "phoneCode": "689"
  },
  {
    "es": "Polonia",
    "code": "PL",
    "iso3": "POL",
    "phoneCode": "48"
  },
  {
    "es": "Portugal",
    "code": "PT",
    "iso3": "PRT",
    "phoneCode": "351"
  },
  {
    "es": "Puerto Rico",
    "code": "PR",
    "iso3": "PRI",
    "phoneCode": "1"
  },
  {
    "es": "Qatar",
    "code": "QA",
    "iso3": "QAT",
    "phoneCode": "974"
  },
  {
    "es": "Reino Unido",
    "code": "GB",
    "iso3": "GBR",
    "phoneCode": "44"
  },
  {
    "es": "República Centroafricana",
    "code": "CF",
    "iso3": "CAF",
    "phoneCode": "236"
  },
  {
    "es": "República Checa",
    "code": "CZ",
    "iso3": "CZE",
    "phoneCode": "420"
  },
  {
    "es": "República Dominicana",
    "code": "DO",
    "iso3": "DOM",
    "phoneCode": "1 809"
  },
  {
    "es": "República de Sudán del Sur",
    "code": "SS",
    "iso3": "SSD",
    "phoneCode": "211"
  },
  {
    "es": "Reunión",
    "code": "RE",
    "iso3": "REU",
    "phoneCode": "262"
  },
  {
    "es": "Ruanda",
    "code": "RW",
    "iso3": "RWA",
    "phoneCode": "250"
  },
  {
    "es": "Rumanía",
    "code": "RO",
    "iso3": "ROU",
    "phoneCode": "40"
  },
  {
    "es": "Rusia",
    "code": "RU",
    "iso3": "RUS",
    "phoneCode": "7"
  },
  {
    "es": "Sahara Occidental",
    "code": "EH",
    "iso3": "ESH",
    "phoneCode": "212"
  },
  {
    "es": "Samoa",
    "code": "WS",
    "iso3": "WSM",
    "phoneCode": "685"
  },
  {
    "es": "Samoa Americana",
    "code": "AS",
    "iso3": "ASM",
    "phoneCode": "1 684"
  },
  {
    "es": "San Bartolomé",
    "code": "BL",
    "iso3": "BLM",
    "phoneCode": "590"
  },
  {
    "es": "San Cristóbal y Nieves",
    "code": "KN",
    "iso3": "KNA",
    "phoneCode": "1 869"
  },
  {
    "es": "San Marino",
    "code": "SM",
    "iso3": "SMR",
    "phoneCode": "378"
  },
  {
    "es": "San Martín (Francia)",
    "code": "MF",
    "iso3": "MAF",
    "phoneCode": "1 599"
  },
  {
    "es": "San Pedro y Miquelón",
    "code": "PM",
    "iso3": "SPM",
    "phoneCode": "508"
  },
  {
    "es": "San Vicente y las Granadinas",
    "code": "VC",
    "iso3": "VCT",
    "phoneCode": "1 784"
  },
  {
    "es": "Santa Elena",
    "code": "SH",
    "iso3": "SHN",
    "phoneCode": "290"
  },
  {
    "es": "Santa Lucía",
    "code": "LC",
    "iso3": "LCA",
    "phoneCode": "1 758"
  },
  {
    "es": "Santo Tomé y Príncipe",
    "code": "ST",
    "iso3": "STP",
    "phoneCode": "239"
  },
  {
    "es": "Senegal",
    "code": "SN",
    "iso3": "SEN",
    "phoneCode": "221"
  },
  {
    "es": "Seychelles",
    "code": "SC",
    "iso3": "SYC",
    "phoneCode": "248"
  },
  {
    "es": "Sierra Leona",
    "code": "SL",
    "iso3": "SLE",
    "phoneCode": "232"
  },
  {
    "es": "Singapur",
    "code": "SG",
    "iso3": "SGP",
    "phoneCode": "65"
  },
  {
    "es": "Sint Maarten",
    "code": "SX",
    "iso3": "SMX",
    "phoneCode": "1 721"
  },
  {
    "es": "Siria",
    "code": "SY",
    "iso3": "SYR",
    "phoneCode": "963"
  },
  {
    "es": "Somalia",
    "code": "SO",
    "iso3": "SOM",
    "phoneCode": "252"
  },
  {
    "es": "Sri lanka",
    "code": "LK",
    "iso3": "LKA",
    "phoneCode": "94"
  },
  {
    "es": "Sudáfrica",
    "code": "ZA",
    "iso3": "ZAF",
    "phoneCode": "27"
  },
  {
    "es": "Sudán",
    "code": "SD",
    "iso3": "SDN",
    "phoneCode": "249"
  },
  {
    "es": "Suecia",
    "code": "SE",
    "iso3": "SWE",
    "phoneCode": "46"
  },
  {
    "es": "Suiza",
    "code": "CH",
    "iso3": "CHE",
    "phoneCode": "41"
  },
  {
    "es": "Surinám",
    "code": "SR",
    "iso3": "SUR",
    "phoneCode": "597"
  },
  {
    "es": "Svalbard y Jan Mayen",
    "code": "SJ",
    "iso3": "SJM",
    "phoneCode": "47"
  },
  {
    "es": "Swazilandia",
    "code": "SZ",
    "iso3": "SWZ",
    "phoneCode": "268"
  },
  {
    "es": "Tayikistán",
    "code": "TJ",
    "iso3": "TJK",
    "phoneCode": "992"
  },
  {
    "es": "Tailandia",
    "code": "TH",
    "iso3": "THA",
    "phoneCode": "66"
  },
  {
    "es": "Taiwán",
    "code": "TW",
    "iso3": "TWN",
    "phoneCode": "886"
  },
  {
    "es": "Tanzania",
    "code": "TZ",
    "iso3": "TZA",
    "phoneCode": "255"
  },
  {
    "es": "Territorio Británico del Océano Índico",
    "code": "IO",
    "iso3": "IOT",
    "phoneCode": "246"
  },
  {
    "es": "Territorios Australes y Antárticas Franceses",
    "code": "TF",
    "iso3": "ATF",
    "phoneCode": ""
  },
  {
    "es": "Timor Oriental",
    "code": "TL",
    "iso3": "TLS",
    "phoneCode": "670"
  },
  {
    "es": "Togo",
    "code": "TG",
    "iso3": "TGO",
    "phoneCode": "228"
  },
  {
    "es": "Tokelau",
    "code": "TK",
    "iso3": "TKL",
    "phoneCode": "690"
  },
  {
    "es": "Tonga",
    "code": "TO",
    "iso3": "TON",
    "phoneCode": "676"
  },
  {
    "es": "Trinidad y Tobago",
    "code": "TT",
    "iso3": "TTO",
    "phoneCode": "1 868"
  },
  {
    "es": "Tunez",
    "code": "TN",
    "iso3": "TUN",
    "phoneCode": "216"
  },
  {
    "es": "Turkmenistán",
    "code": "TM",
    "iso3": "TKM",
    "phoneCode": "993"
  },
  {
    "es": "Turquía",
    "code": "TR",
    "iso3": "TUR",
    "phoneCode": "90"
  },
  {
    "es": "Tuvalu",
    "code": "TV",
    "iso3": "TUV",
    "phoneCode": "688"
  },
  {
    "es": "Ucrania",
    "code": "UA",
    "iso3": "UKR",
    "phoneCode": "380"
  },
  {
    "es": "Uganda",
    "code": "UG",
    "iso3": "UGA",
    "phoneCode": "256"
  },
  {
    "es": "Uruguay",
    "code": "UY",
    "iso3": "URY",
    "phoneCode": "598"
  },
  {
    "es": "Uzbekistán",
    "code": "UZ",
    "iso3": "UZB",
    "phoneCode": "998"
  },
  {
    "es": "Vanuatu",
    "code": "VU",
    "iso3": "VUT",
    "phoneCode": "678"
  },
  {
    "es": "Venezuela",
    "code": "VE",
    "iso3": "VEN",
    "phoneCode": "58"
  },
  {
    "es": "Vietnam",
    "code": "VN",
    "iso3": "VNM",
    "phoneCode": "84"
  },
  {
    "es": "Wallis y Futuna",
    "code": "WF",
    "iso3": "WLF",
    "phoneCode": "681"
  },
  {
    "es": "Yemen",
    "code": "YE",
    "iso3": "YEM",
    "phoneCode": "967"
  },
  {
    "es": "Yibuti",
    "code": "DJ",
    "iso3": "DJI",
    "phoneCode": "253"
  },
  {
    "es": "Zambia",
    "code": "ZM",
    "iso3": "ZMB",
    "phoneCode": "260"
  },
  {
    "es": "Zimbabue",
    "code": "ZW",
    "iso3": "ZWE",
    "phoneCode": "263"
  }
];

export default countriesEs;